(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mons-aviso-cookies"] && !Shopify.designMode) return;
  try {
    (function () {
    var CLAVE = 'mons-cookies-visto';
    var aviso = document.getElementById('mons-cookies');
    var boton = document.getElementById('mons-cookies-ok');

    if (!aviso || !boton) return;

    // localStorage puede lanzar en modo privado o con las cookies de sitio bloqueadas.
    // Si no se puede leer, se muestra el aviso: informar de mas es preferible a no informar.
    function yaLoVio() {
      try {
        return window.localStorage.getItem(CLAVE) === '1';
      } catch (e) {
        return false;
      }
    }

    function recordar() {
      try {
        window.localStorage.setItem(CLAVE, '1');
      } catch (e) {
        /* Sin persistencia el aviso vuelve a salir. Es el peor caso aceptable. */
      }
    }

    if (yaLoVio()) return;

    aviso.hidden = false;

    boton.addEventListener('click', function () {
      recordar();
      aviso.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
